module.exports = __webpack_public_path__ + "static/media/basel-43.9636026b.jpg";